export default "__VITE_ASSET__DjiM4oxt__"